// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","698":"albumsForm","817":"albumsList"}[chunkId] + "." + {"328":"b15cd9a299a6f6874b8b","698":"5287e254854ee8c7925f","817":"5287e254854ee8c7925f"}[chunkId] + ".css";
};